import React from 'react'
import AffiliateBadgeUi from './ui/AffiliateBadgeUi'
import { PageLocaleEnum } from 'common/enums/PageLocaleEnum'

type AffiliateBadgeProps = {
  affiliateLink?: string
  pageLocale?: PageLocaleEnum
}

//  All existing affiliate badge images
//  https://eu-west-1.console.aws.amazon.com/s3/buckets/shared.systeme.io?prefix=images/affiliate-badge/&region=eu-west-1&tab=objects

const AffiliateBadge = ({
  affiliateLink = '',
  pageLocale = PageLocaleEnum.ENGLISH,
}: AffiliateBadgeProps) => {
  const src = `${process.env.CLOUDFRONT_SHARED}/images/affiliate-badge/badge-${pageLocale}.svg`
  const fallback = `${process.env.CLOUDFRONT_SHARED}/images/affiliate-badge/badge-en.svg`

  const badge = (
    <AffiliateBadgeUi>
      {/** biome-ignore lint/a11y/useAltText: <explanation> */}
      <img
        src={src}
        onError={e => {
          e.currentTarget.src = fallback
        }}
      />
    </AffiliateBadgeUi>
  )

  return affiliateLink ? (
    <a href={affiliateLink} target="_blank" rel="noopener noreferrer">
      {badge}
    </a>
  ) : (
    badge
  )
}

export default AffiliateBadge
